/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMarkAuctionAsFullyPayedStatus } from '../fn/auction-payment/get-mark-auction-as-fully-payed-status';
import { GetMarkAuctionAsFullyPayedStatus$Params } from '../fn/auction-payment/get-mark-auction-as-fully-payed-status';
import { markAuctionAsFullyPayed } from '../fn/auction-payment/mark-auction-as-fully-payed';
import { MarkAuctionAsFullyPayed$Params } from '../fn/auction-payment/mark-auction-as-fully-payed';
import { MarkAuctionPaymentProcessStatus } from '../models/mark-auction-payment-process-status';

@Injectable({ providedIn: 'root' })
export class GeneratedAuctionPaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `markAuctionAsFullyPayed()` */
  static readonly MarkAuctionAsFullyPayedPath = '/api/auction-payments/{auctionId}';

  /**
   * Marks the given auction as fully payed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAuctionAsFullyPayed()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAuctionAsFullyPayed$Response(params: MarkAuctionAsFullyPayed$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkAuctionPaymentProcessStatus>> {
    return markAuctionAsFullyPayed(this.http, this.rootUrl, params, context);
  }

  /**
   * Marks the given auction as fully payed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAuctionAsFullyPayed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markAuctionAsFullyPayed(params: MarkAuctionAsFullyPayed$Params, context?: HttpContext): Observable<MarkAuctionPaymentProcessStatus> {
    return this.markAuctionAsFullyPayed$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarkAuctionPaymentProcessStatus>): MarkAuctionPaymentProcessStatus => r.body)
    );
  }

  /** Path part for operation `getMarkAuctionAsFullyPayedStatus()` */
  static readonly GetMarkAuctionAsFullyPayedStatusPath = '/api/auction-payments/{auctionId}/status';

  /**
   * Gets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMarkAuctionAsFullyPayedStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarkAuctionAsFullyPayedStatus$Response(params: GetMarkAuctionAsFullyPayedStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkAuctionPaymentProcessStatus>> {
    return getMarkAuctionAsFullyPayedStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMarkAuctionAsFullyPayedStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarkAuctionAsFullyPayedStatus(params: GetMarkAuctionAsFullyPayedStatus$Params, context?: HttpContext): Observable<MarkAuctionPaymentProcessStatus> {
    return this.getMarkAuctionAsFullyPayedStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarkAuctionPaymentProcessStatus>): MarkAuctionPaymentProcessStatus => r.body)
    );
  }

}
